module.exports = __webpack_public_path__ + "static/tecnologia-276b86d925fb721b0540f4a02d66c5fd.webp";